<main class="main-container">
    <div class="container-fluid">
        <div class="loading" *ngIf="loading == true">Loading&#8230;</div>
        <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">
        <div class="main-header">
            <button (click)="backToMaps()" class="button" id="backButton">
                <mat-icon>arrow_back_ios</mat-icon>
            </button>

            <div class="main-title">
                <h3>OPTIONS FOR THIS PROPERTY</h3>
            </div>

            <div class="main-header-spacer" aria-hidden="true"></div>
        </div>

        <div class="row p-2 ">
            <div class="col-12 col-lg-8">
                <div class="report-card property-summary-card">
                    <div class="property-summary-row">
                        <div class="property-image-col">
                            <div class="property-image">
                                <img [src]="ImageFileUrl" alt="Property Image" (error)="ImageFileUrl = placeholderImage" />
                            </div>
                        </div>
                        <div class="property-details-col">
                            <div class="report-content details">
                                <div class="header pt-2">
                                    <span class="price">{{ getPropertyPriceDisplay(advertDetails?.propertyInfoPrice)
                                        }}</span>
                                </div>
                                <div class="address pt-2">
                                    {{ advertDetails.propertyInfoSizeTypeLocation }}
                                </div>
                                <div class="highest-best pt-2">
                                    {{ advertDetails.propertyInfoAdvertType }}
                                </div>
                                <div class="description pt-2">
                                    {{ advertDetails?.propertyInfoShortDescription }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="report-card" *ngIf="isLeafletType == false">
                    <div class="report-header report-header-underline mb-4">Free Planning Report</div>
                    <div class="report-content">
                        <div class="report-sub-header p-2">Detailed professional report:</div>
                        <ul class="report-list">
                            <li>Potential land uses (zoning); and</li>
                            <li>Improvement options</li>
                            <li>Development options, considering potential rights</li>
                        </ul>
                    </div>
                    <div class="report-footer text-center pt-2">
                        <button type="button" class="btn btn-primary"
                            (click)="downloadPlanningReport()">Download</button>
                    </div>
                </div>
                <div class="report-card" *ngIf="isLeafletType == true">
                    <div class="report-header report-header-underline mb-4">Leaflet</div>
                    <div class="report-content">
                        <div class="report-sub-header">One-Pager Property Brief:</div>
                        <ul class="report-list">
                            <li>Prepared by a Property Practitioner</li>
                            <li>Not verified by a Registered Planner</li>
                        </ul>
                    </div>
                    <div class="report-footer text-center pt-2">
                        <button type="button" class="btn btn-primary"
                            (click)="downloadPlanningReport()">Download</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Planning Insights-->
        <div class="row p-2" *ngIf="advertDetails?.advertPlanningInsights?.length">
            <div class="col-12">
                <div class="report-card">
                    <div class="report-header pt-2 mb-4">Planning Insights</div>
                    <div class="report-content">
                        <div class="planning-insights">
                            <ul class="planning-insights">
                                <li *ngFor="let planning of advertDetails?.advertPlanningInsights">
                                    {{ planning?.description }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--key features-->
        <div class="row p-2">
            <div class="col-12">
                <div class="report-card">
                    <div class="report-header pt-2 mb-4">KEY FEATURES</div>
                    <div class="report-content">
                        <ul class="report-list-features">
                            <li *ngFor="let feature of advertDetails?.advertKeyFeatures">
                                {{ feature?.description }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!--CONTACT OUR NETWORK-->
        <div class="row p-2">
            <div class="col-12">
                <div class="report-card">
                    <div class="report-header pt-2 mb-4">CONTACT OUR NETWORK</div>
                    <div class="report-content">
                        <div class="button-row button-row-6">
                            <div class="contact-item" *ngFor="let email of emails; let i = index">
                                <button type="button" class="envelope-btn" (click)="sendEmail(email)">
                                    <i class="fas fa-envelope"></i>
                                </button>
                                <div class="contact-label">{{ email.label }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- make an offer and  share this property-->
        <div class="row p-2">
            <div class="col-12 col-lg-6">
                <div class="report-card ">
                    <div class="report-header pt-2 mb-4">MAKE AN OFFER</div>
                    <div class="report-content">
                        <div class="contact-item">
                            <button class="envelope-btn active" (click)="sendMakeAnOfferEmail()">
                                <i class="fas fa-clipboard"></i>
                            </button>
                            <div class="contact-label">OFFER TO PURCHASE</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="report-card ">
                    <div class="report-header pt-2 mb-4">SHARE THIS PROPERTY</div>
                    <div class="report-content">
                        <div class="button-row button-row-6">
                            <div class="contact-item">
                                <button class="envelope-btn active" (click)="sendEmailToFriend()">
                                    <i class="fas fa-envelope"></i>
                                </button>
                                <div class="contact-label">MAIL</div>
                            </div>
                             <div class="contact-item">
                          <button class="instagram-btn" (click)="shareOnInstagram()">
                            <i class="fab fa-instagram"></i>
                          </button>
                          <div class="contact-label">INSTAGRAM</div>
                        </div>
                            <div class="contact-item">
                                <button class="facebook-btn" (click)="shareOnFacebook()">
                                    <i class="fab fa-facebook"></i>
                                </button>
                                <div class="contact-label">FACEBOOK</div>
                            </div>
                            <div class="contact-item">
                                <button class="twitter-btn" (click)="shareOnTwitter()">
                                    <i class="fab fa-x-twitter"></i>
                                </button>
                                <div class="contact-label">X</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Carosel of 3 pictures at a time -->
        <div class="row p-2 ">
            <div class="col-12">
                <div class="report-card">
                    <div class="report-header pt-2 mb-4">GALLERY</div>
                    <div class="report-content">
                        <div class="carousel-container">
                            <div class="carousel-wrapper">
                                <button mat-icon-button class="carousel-button left" (click)="prevSlide()"
                                    [disabled]="currentIndex === 0" aria-label="Previous slide">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>

                                <div class="carousel-track">
                                    <div class="carousel-slide-content">
                                        <div class="image-group" *ngFor="let item of getVisibleItems(); let i = index">
                                            <img [src]="item.image" [alt]="item.title" class="carousel-image"
                                                (error)="item.image = placeholderImage"
                                                (click)="openImagePopup(item)" />
                                        </div>
                                    </div>
                                </div>

                                <button mat-icon-button class="carousel-button right" (click)="nextSlide()"
                                    [disabled]="currentIndex >= items.length - itemsPerSlide" aria-label="Next slide">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Image Modal Popup -->
        <div class="image-popup-overlay" *ngIf="selectedImage" (click)="closeImagePopup()">
            <div class="image-popup-content" (click)="$event.stopPropagation()">
                <img [src]="selectedImage.image" [alt]="selectedImage.title" alt="placeholder" />
                <span class="close-button" (click)="closeImagePopup()">×</span>
            </div>
        </div>
    </div>
</main>
